import React, { Component } from 'react';
import { connect } from 'react-redux';
import Title from '../../helper/title';
import {reduxForm,Field,SubmissionError } from 'redux-form';
import M from 'materialize-css/dist/js/materialize.min.js'
import renderOption from '../../helper/option';
import {fee} from '../../../config';
import BN from 'bn.js';
import renderInput from '../../helper/input';
import Modal from '../../helper/modal';
import {setAmount,setFee} from '../../../actions/ui/passport';
import {consolidateNRG,showTxs,payNEO,payBTC,payETH,payLSK,payWAV,payNRG,payEMB,payDAI,payUSDT} from '../../../actions/transfers/set';
import {getNEOFee,getBTCFee,getETHFee,getLSKFee,getWAVFee,getNRGFee,getEMBFee,getDAIFee,getLEMBFee,getUSDTFee} from '../../../actions/transfers/fees';
import TransferDetails from '../../helper/transferDetails';
import Circle from '../../helper/circle';
import $ from "jquery";
import {COIN_FRACS, internalToHuman} from 'bc-sdk/dist/utils/coin'
import {Decimal} from 'decimal.js';
import QRCode from 'react-qr-code';
import QrReader from './qr-scanner/index'
import isElectron from 'is-electron';
import consolidate from './consolidate.svg';
import {isMobile} from 'react-device-detect';

class Transfers extends Component {
  constructor(){
    super();
    this.state = {view: 'nrg',view2:'nrg',to:'',txs:[],result:'Scanning...',showCam:false,loaded:false};
  }
  handleScan(data){
    if(data && data.length > 0){
      var instance = M.Modal.getInstance(document.querySelectorAll('#modalScan')[0]);
      if(instance) instance.close();
      $('#to')[0].value = data;
      this.setState({to:data,loaded:false,showCam:false})
    }
  }
  handleError(err){
    console.error(err)
  }
  renderTxs(){
    if(this.state.txs.length > 0){
      let sum = 0;
      return this.state.txs.map((amount,i)=>{
        let sum = internalToHuman(new BN(amount.add(fee).toString()), COIN_FRACS.NRG)
        amount = internalToHuman(new BN(amount.toString()), COIN_FRACS.NRG)
        return (
          <>
          <div className='row mbd'>
            <div className="row mi">
              <h6 className='leftInfo'><b>Amount</b></h6>
              <h6 className="rightInfo">{amount} OVERLINE</h6>
            </div>

            <div className="row mi">
              <h6 className='leftInfo'><b>Fee</b></h6>
              <h6 className="rightInfo">{internalToHuman(fee,COIN_FRACS.NRG)} OVERLINE</h6>
            </div>

            <div className="row mi">
              <h6 className='leftInfo'><b>Total</b></h6>
              <h6 className="rightInfo">{sum} OVERLINE</h6>
            </div>
          </div>
          {i != this.state.txs.length-1 ? <hr/> : null}
          </>
        )
      })
    }
    else {
      return (<div> No transaction to consolidate.</div>)
    }
  }
  closeScan(){
    this.setState({showCam:false,loaded:false})
  }
  handleLoad(){
    setTimeout(()=>{
      this.setState({loaded:true})
    },50)
  }
  renderQRScan(){
    let component = (
      <div>
        <div style={{position:'fixed',height:'270px',maxWidth:'480px',border:'2px solid grey'}}>
          {this.state.loaded === false && <p style={{zIndex:1,lineHeight:'270px',textAlign:'center'}}> Loading Camera...</p> }
        </div>
        {this.state.showCam &&
          <div style={{zIndex:10}}>
          <QrReader
            delay={100}
            style={{border:'2px solid grey'}}
            style={{height:270,maxWidth:480}}
            onLoad={this.handleLoad.bind(this)}
            onError={this.handleError.bind(this)}
            onScan={this.handleScan.bind(this)}
            />
          </div>
        }
      </div>
    )
    return (
      <Modal title='Scan QR Code' id='modalScan' closeAction={this.closeScan.bind(this)} style={{maxWidth:'530px'}} classes='modal modalOrders black-text' noClose={true} component={component} />
    )
  }
  renderModal(){
    let component = (<TransferDetails amount={this.props.amount} to={this.props.addressText} to={this.state.to} from={this.props.addressText} fee={this.props.fee} chain={this.props.view.toUpperCase()} />)
    let chain = this.props.view.toUpperCase();
    return (
      <Modal id='modalTransfer' title={`Transfer ${this.props.view.toUpperCase().replace('NRG','OVERLINE')}`} style={{maxWidth:'500px'}} classes='modal modalOrders black-text' chain={chain} noClose={true} passwordId="passwordTransfer" component={component} isOrder={false} decryption={true} buttonText={"Confirm"} buttonAction={this.submitOperation.bind(this)} />
    )
  }

  submitConsolidate(){
    let _this = this;
    let password = $("#passwordConsolidation").val();
    var instance = M.Modal.getInstance(document.querySelectorAll('#modalConsolidation')[0]);
    this.setState({showChecking:true})

    setTimeout(()=>{
      if(this.state.showChecking) {
        M.toast({html: 'Submitting Transaction',classes:"grey",displayLength:3000});
        if (instance) instance.close();
      }
    },50);

    this.props.consolidateNRG({password,address:this.props.addressText,txs:this.state.txs},(err,txs)=>{
      if(!err) {
        $("#passwordConsolidation")[0].value = '';
        _this.setState({txs:[],showChecking:false})
        if(instance) instance.close();
        setTimeout(()=>{
          M.toast({html: 'Transactions Submitted!',classes: "green",displayLength:3000});
        },200);
      }
      else {
        this.setState({showChecking:false})
        if(instance) instance.open();
        M.toast({html: err,classes:"red",displayLength:3000});
      }
    })
  }
  closeConsolidate(){
    this.setState({txs:[]})
  }
  renderLoadingTxs(){
    return (
      <div className='row mbd'>
        <div className='col s12'>
          <h6 style={{marginLeft:'10px',marginBottom:'10px'}}> Loading Txs... </h6>
        </div>
      </div>
    )
  }
  renderConsolidate(){
    let component = (
      <div style={{overflowY:'scroll',maxHeight:'500px'}}>
        {this.props.loading_txs ? this.renderLoadingTxs() : this.renderTxs()}
      </div>
    );
    return (
      <Modal id='modalConsolidation' title={`Consolidate UTXOs`} style={{maxWidth:'500px'}} passwordId='passwordConsolidation' classes='modal modalOrders black-text' noClose={true} component={component} decryption={true} buttonText={"Send Txs"} closeAction={this.closeConsolidate.bind(this)} buttonAction={this.submitConsolidate.bind(this)} />
    )
  }
  componentDidMount(){
    $('#to').focus();
  }
  componentWillReceiveProps(newProps){
    if(this.props.view !==newProps.view){
      if(newProps.view === 'btc' || newProps.view == 'nrg') {
        this.props[`get${newProps.view.replace('-','').toUpperCase()}Fee`](newProps.amount,newProps.addressText);
      }
      else {
        this.props[`get${newProps.view.replace('-','').toUpperCase()}Fee`](newProps.amount);
      }
    }
  }
  onChangeAmount(e){
    this.props.setAmount(e.target.value,()=>{});
    if(this.props.view === 'btc' || this.props.view == 'nrg') {
      this.props[`get${this.props.view.replace('-','').toUpperCase()}Fee`](e.target.value,this.props.addressText);
    }
    else {
      this.props[`get${this.props.view.replace('-','').toUpperCase()}Fee`](e.target.value);
    }
  }
  changeAmount(percent){
    let newAmount = new Decimal(this.props.availableAmount).mul(new Decimal(percent)).toNumber()
    this.props.setAmount(newAmount,()=>{})
    if(this.props.view === 'btc' || this.props.view == 'nrg') {
      this.props[`get${this.props.view.replace('-','').toUpperCase()}Fee`](newAmount,this.props.addressText);
    }
    else {
      this.props[`get${this.props.view.replace('-','').toUpperCase()}Fee`](newAmount);
    }
  }
  changeAmount100(percent){
    let newAmount = new Decimal(this.props.availableAmount).mul(new Decimal(percent)).toNumber()
    let fun = ()=>{
      let val = new Decimal(newAmount).sub(new Decimal(this.props.fee)).toNumber()
      if(['emb','dai','usdt'].includes(this.props.view)) val = newAmount
      $('#amount')[0].value = val;
      this.props.setAmount(val,()=>{})
    }
    if(this.props.view === 'btc' || this.props.view == 'nrg') {
      this.props[`get${this.props.view.replace('-','').toUpperCase()}Fee`](newAmount,this.props.addressText,fun);
    }
    else {
      this.props[`get${this.props.view.replace('-','').toUpperCase()}Fee`](newAmount,fun);
    }
  }
  onChangeTo(e){
    this.setState({to:e.target.value});
  }
  submitOperation(){
    let password = $("#passwordTransfer").val();
    var instance = M.Modal.getInstance(document.querySelectorAll('#modalConsolidation')[0]);
    this.setState({showChecking:true})

    setTimeout(()=>{
      if(this.state.showChecking) {
        M.toast({html: 'Submitting Transaction',classes:"grey",displayLength:3000});
        if (instance) instance.close();
      }
    },100);

    this.props[`pay${this.props.view.toUpperCase()}`]({password,address:this.props.addressText,amount:this.props.amount,to:this.state.to},(err,tx)=>{
      if(!err) {
        $('#amount')[0].value = '';
        $('#to')[0].value = '';
        this.props.setFee('',()=>{});
        this.props.setAmount('',()=>{})
        var instance = M.Modal.getInstance(document.querySelectorAll('#modalTransfer')[0]);
        if(instance) instance.close();
        this.setState({showChecking:false})
        setTimeout(()=>{
          M.toast({html: 'Transaction Submitted!',classes: "green",displayLength:3000});
        },200);
      }
      else {
        M.toast({html: err,classes:"red",displayLength:3000});
        if (instance) instance.open();
        this.setState({showChecking:false})
      }
    })
  }
  viewQR() {
    setTimeout(()=>{
      var instance = M.Modal.getInstance(document.querySelectorAll('#modalQR')[0]);
      instance.open();
    },100);
  }
  scanQR() {
    if(isElectron()){
      // const { systemPreferences } = require('electron');
      // systemPreferences.askForMediaAccess('camera')
    }
    this.setState({showCam:true})
    setTimeout(()=>{
      var instance = M.Modal.getInstance(document.querySelectorAll('#modalScan')[0]);
      instance.open();
    },100);
  }
  openConsolidation() {
    let _this = this;
    this.props.showTxs({address:this.props.addressText},(err,txs)=>{
      if(!err) _this.setState({txs})
      else M.toast({html: err,classes:"red",displayLength:3000});
    })
    setTimeout(()=>{
      var instance = M.Modal.getInstance(document.querySelectorAll('#modalConsolidation')[0]);
      instance.open();
      setTimeout(()=>{
        if($("#passwordConsolidation")) $("#passwordConsolidation").focus()
      },100)
    },100);
  }
  handleFormSubmit() {
    setTimeout(()=>{
      var instance = M.Modal.getInstance(document.querySelectorAll('#modalTransfer')[0]);
      instance.open();
      setTimeout(()=>{
        if($("#passwordTransfer")) $("#passwordTransfer").focus()
      },100)
    },100);
  }
  copyFrom(){
    var copyText = document.getElementById("from");

    var textField = document.createElement('textarea')
    textField.innerText =  copyText.value
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
    M.toast({html: 'Copied Address',classes:"black",displayLength:3000});
  }
  renderForm(){
    const { handleSubmit } = this.props;
    let k = ['USDT','DAI','EMB','L-EMB'].includes(this.props.view.toUpperCase()) ? 'ETH' : this.props.view.toUpperCase()

    let label2 = `Miner Fee: ${this.props.fee} ${k.replace('NRG','OL')}`;
    return (
      <form onSubmit={handleSubmit(this.handleFormSubmit.bind(this))} style={{zoom:1.1}} autoComplete='off'>
        <div className="row" style={{paddingTop:'5px'}}>
          <i className="material-icons searchIcon" onClick={this.copyFrom.bind(this)} style={{marginLeft:'10px',marginTop:'32px',cursor:'pointer'}}>content_copy</i>
          <Field name="from" _id='from' onclick={this.copyFrom.bind(this)} component={renderInput} type="text" label={`From:`} disabled={true} val={this.props.addressText}  />
          <i className="material-icons searchIcon" onClick={this.scanQR.bind(this)} style={{fontSize:'17px',marginLeft:'10px',marginTop:'32px',cursor:'pointer'}} >center_focus_weak</i>
          <Field name="to" _id='to' onChang={this.onChangeTo.bind(this)} component={renderInput} step={'any'} type="text" label={`Recipient:`} required={true}/>
          <Field name="amount" _id='amount' onChang={this.onChangeAmount.bind(this)} component={renderInput} step={'any'} type="number" label={`Amount:`} label2={label2} required={true}/>
          {this.renderBalance()}
        </div>
      </form>
    )
  }
  renderBalance(){
    return (
      <div className='row' style={{paddingRight:'0.75em',paddingLeft:'0.75em',marginRight: "2px",marginLeft:'2px'}}>
        <div id='placeOrderBal' className='col s6' style={{padding:0}}>
          <p style={{margin:0,fontSize:'0.8em'}}>Balance: {this.props.availableAmount.toString().slice(0, 12)} {this.props.view.toUpperCase() === 'NRG' ? 'OL' : this.props.view.toUpperCase()}
            {this.props.view && !['emb','l-emb','nrg'].includes(this.props.view.toLowerCase()) ?
              <span style={{color:'white',opacity:0.75,position:'absolute', marginLeft:5}}> ({Math.round(100*this.props.availableAmount*this.props.price[this.props.view.toLowerCase()])/100} USD)</span>
              : <span style={{color:'black',position:'absolute'}}>|</span>
            }
          </p>
        </div>
        <div id='placeOrderNums' className='col s6' style={{padding:0,marginTop:'-2px'}}>
          <div className='col s3'>
            <p style={{margin:0}} onClick={this.changeAmount.bind(this,0.1)}>10%</p>
          </div>
          <div className='col s3'>
            <p style={{margin:0}} onClick={this.changeAmount.bind(this,0.25)}>25%</p>
          </div>
          <div className='col s3'>
            <p style={{margin:0}} onClick={this.changeAmount.bind(this,0.5)}>50%</p>
          </div>
          <div className='col s3'>
            <p style={{margin:0}} className='tooltipped' data-position="bottom" data-tooltip={`Full Balance - ${this.props.view.toUpperCase()} Tx Fee`} onClick={this.changeAmount100.bind(this,1)}>Max</p>
          </div>
        </div>
      </div>
    )
  }
  click(e){
    e.stopPropagation()
    return
  }
  render() {
    let src = `/${this.props.view.toLowerCase()}.png`;
    let disabled = parseFloat(this.props.availableAmount) < parseFloat(this.props.amount)

    return (
      <div className="col s12 m6 transfers" style={{borderRight:isMobile ? 'none': '1px solid grey'}}>
        <Title text='transfer' />

        <div className='col s12 m10 offset-m1' style={{}}>
          {this.renderForm()}
        </div>
        {this.props.view.toUpperCase() === 'NRG' &&
          <div className='col s12 m10 offset-m1' style={{marginTop:'10px',}}>
            <button style={{width:'120px',fontSize:'8px',float:'left',height:'20px'}} onClick={this.openConsolidation.bind(this)} className="btn clickablesWhite"> Consolidate TXs
            </button>
          </div>
        }
        <div className="col s12 center" style={{marginTop:'40px'}}>
          <button className="btn clickablesWhite" style={{width:'150px'}} disabled={disabled} onClick={this.handleFormSubmit.bind(this)}> Send {this.props.view.toUpperCase() === 'NRG' ? 'OL' : this.props.view.toUpperCase()}
            <i className="material-icons" style={{float: 'right',marginRight:"5px"}}>send</i>
          </button>
        </div>


        {this.renderConsolidate()}
        {this.renderModal()}
        {this.renderQRScan()}
      </div>
		)
  }
}

Transfers = reduxForm({
  form: 'transfers',  // name of the form
})(Transfers);

function mapStateToProps(state,props) {
  let asset = state.ui_passport.asset_view.toLowerCase();
  let address = state.ui_passport.address_view;
  return {
    loading_txs: state.ui_passport.loading_txs,
    price: state.price,
    fee: state.passport.fee,
    amount: state.ui_passport.amount,
    view: asset,
    addressText: address,
    availableAmount: state.passport[asset] && state.passport[asset][address] ? state.passport[asset][address] : 0,
  };
}


export default connect(mapStateToProps, {setAmount,setFee, showTxs,
  getNEOFee,getBTCFee,getETHFee,getLSKFee,getWAVFee,getNRGFee,getEMBFee,getDAIFee,getLEMBFee,getUSDTFee, consolidateNRG,
  payNEO,payBTC,payETH,payLSK,payWAV,payNRG,payEMB,payDAI,payUSDT
})(Transfers);
